import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';

import { queryClient } from '../../configs/queryClient';
import useServiceHistoryQuery from '../useServiceHistoryQuery';

async function attachFallback(axios: AxiosInstance, serviceHistoryRequestId: number): Promise<object> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v1/service-history-request/${serviceHistoryRequestId}/confirmation-fallback`);
  return data;
}

export function useAttachFallbackEmptyServiceHistoryMutation(serviceHistoryRequestId: number) {
  const axios = useAxios();
  const toast = useToast();

  return useMutation({
    mutationKey: ['AttachFallbackEmptyServiceHistory'],
    mutationFn: () => attachFallback(axios, serviceHistoryRequestId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: useServiceHistoryQuery.getKey(serviceHistoryRequestId) });
    },
    onError: (error: any) => {
      manageErrorResponse(toast, error.response);
    },
  });
}

useAttachFallbackEmptyServiceHistoryMutation.getKey = (id: number) => ['AttachFallbackEmptyServiceHistory', id] as const;
